import moment from 'moment';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSwarm, swarmLayers } from '@lbs/swarm-client';

import { PreferencesContext } from '@common/contexts/preferences';
import OddConverter from '@common/helpers/oddConverter';
import { useTranslation } from '@common/hooks/translation';
import { normalizeAlias } from '@common/helpers';
import { asyncWrapper } from '@common/hocs/asyncWrapper';

import MultiplesItemPlaceBet from './multiplesItemPlaceBet';
import { getPredefinedMultiples } from '../service';

const MultiplesItem = ({
  balance, config, partnerConfig, currencyConfig, multiple,
}) => {
  const t = useTranslation();
  const [{ oddsFormat }] = useContext(PreferencesContext);
  const multiplesItemRequest = useMemo(() => {
    const selectionIds = [];
    const gameIds = [];

    multiple.Selections.forEach((item) => {
      selectionIds.push(item.SelectionId);
      gameIds.push(item.MatchId);
    });

    return getPredefinedMultiples(selectionIds, gameIds);
  }, [multiple]);

  const events = swarmLayers(useSwarm(multiplesItemRequest), 'event');

  return (
    <div className="multiple-block">
      <div className="predefined-multiples-header">
        <div className="info-block">
          <div className="info-part">
            <div className="info-name">
              <span className="multiple-name">
                {multiple.Name}
                <span className="multiple-selections-count">{multiple.Selections.length}</span>
              </span>
            </div>
            {!!multiple.Order && <span className="multiple-selections-order">{multiple.Order}</span>}
          </div>
          <p className="multiple-expires-at">
            <span className="expires-at">{t('Expires At:')}</span>
            {moment(multiple.ExpiresAt).format(config.main.dateFormat)}
          </p>
        </div>
        <div className="predefined-multiples-check-lists select-sport-contain">
          <div className="scrollable-container">
            {events.map((event) => (
              <div key={event.id} className="multiples-event-itm">
                <div className="multiples-list-top-row">
                  <span className={`sport-icon sport-icon-${event.sport.alias}`} />
                  <span className={`flag icon-${normalizeAlias(event.region.alias)}`} />
                  <p className="multiples-list-title-team">{event.competition.name}</p>
                  <span className="event-game-time">{moment.unix(event.game.start_ts).format(config.sportsbook.timeFormat)}</span>
                </div>
                <div className="multiples-list-middle-row-wrp">
                  <div className="multiples-list-middle-row">
                    <p className="multiples-list-team-name wide-text">{event.game.team1_name}</p>
                    <span className="multiples-list-team-vs">-</span>
                    <p className="multiples-list-team-name wide-text">{event.game.team2_name}</p>
                  </div>
                </div>
                <div className="multiples-list-bottom-row">
                  <p className="m-l-b-txt">{event.market.name}</p>
                  <div className="m-l-b-coef-wrp">
                    <span className="m-l-b-coef">
                      {event.name}
                      {event.market.base ? `${event.market.base}` : ''}
                    </span>
                  </div>
                  <span className="m-l-b-number">{OddConverter(config, event.price, oddsFormat)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <MultiplesItemPlaceBet
        multiple={multiple}
        events={events}
        balance={balance}
        config={config}
        partnerConfig={partnerConfig}
        currencyConfig={currencyConfig}
      />
    </div>
  );
};

MultiplesItem.propTypes = {
  multiple: PropTypes.object,
  balance: PropTypes.number,
  config: PropTypes.object.isRequired,
  partnerConfig: PropTypes.object.isRequired,
  currencyConfig: PropTypes.object.isRequired,

};

export default asyncWrapper(MultiplesItem, () => { }, null);
